<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col md="6">
        <FormCompany @submit="submit" :title="'Update Company'" :form="form"></FormCompany>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import FormCompany from '@/views/admin/company/FormCompany'
import axios from 'axios'

export default {
  name: 'updatecompany',
  components: {
    FormCompany
  },  
  data () {
    return {
      form: {}
    }
  },
  computed: {
    id: function () {
      return this.$route.params.id
    }
  },
  methods: {
    submit (form) {
      let scope = this; 

      if(!form.name) {
        console.log('invalid')
        return
      }

      form._id = scope.id;
      form.user = scope.$store.getters.currentUser.id

      axios.put(process.env.VUE_APP_API + '/company/' + form._id, form, {
      headers: {
        Authorization: 'JWT ' + scope.$localStorage.get('holly-fi-token')
        }
      })
        .then(function (response) {
          scope.$router.push('/admin/companies/list')
        })
        .catch(function (error) {
          console.log(error);
        });
    }
  },
  created () {
    let scope = this;
    axios.get(process.env.VUE_APP_API + '/company/' + scope.id, {
      headers: {
        Authorization: 'JWT ' + scope.$localStorage.get('holly-fi-token')
        }
      })
        .then(function (response) {
          scope.form = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
  }
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
